export const isTokenExpired = (token) => {
  if (!token) return true;
  const [, payload] = token.split(".");
  const decodedPayload = JSON.parse(atob(payload));
  const expiry = decodedPayload.exp * 1000;
  // console.log(expiry, Date.now(), "expiry");
  return Date.now() > expiry;
};
